import React, { useEffect, useState } from "react";
import FeaturesCom from "../components/FeaturesCom";
import AboutComp2 from "../components/AboutComp2";
import FeaturesInfoComp from "../components/FeaturesInfoComp";
import FeesAndCharges from "../components/FeesAndCharges";
import CreditCardHeading from "../components/CreditCardHeading";
import { CircularProgress } from "@mui/material";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CreditCardProp from "../components/CreditCardProp";
import BreadcrumbNav from "../components/BreadcrumbNav";
import PageSEO from "../components/SEO_Component/PageSEO";

const IndivdualCreditCard = () => {
  const { lang, id } = useParams();
  const [card, setCard] = useState({});

  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const getKeyFeature = (card) => {
    return [
      {
        title: card.credit_card_page.free_lounge_access,
        value: card.lounge == "Yes" ? true : false,
      },
      {
        title: "Fuel Surcharge",
        value: card.fuel_surcharge == "Yes" ? true : false,
      },
    ];
  };

  const getFeeAndCharges = (card) => {
    return [
      {
        title: "Joining Fees",
        value: card.joining_fees,
      },
      {
        title: "Late Fees",
        value: card.late_fees,
      },
      {
        title: "Renewal Fees",
        value: card.renewal_fees,
      },
      {
        title: "Fuel Surcharge Percentage",
        value: card.fuel_surcharge_percentage,
      },
    ];
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API}${lang}/credit-card/${id}?debug=true`
        );
        const data = await response.json();
        setCard(data);
        console.log(card);
        setIsLoading(false);
        window.scrollTo({
          top: 0,
          behavior: "instant",
        });
      } catch (e) {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [lang, id]);

  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}

      {!isLoading &&
        card.title &&
        card.image &&
        card.bank &&
        card.bank.image &&
        card.lounge && (
          <>
            <BreadcrumbNav
              pathSegments={[
                {
                  caption: "Home",
                  href: `/${lang}`,
                },
                {
                  caption: "Credit Cards",
                  href: `/${lang}/credit-cards`,
                },
                {
                  caption: card.title,
                  href: location.pathname,
                },
              ]}
            />
            <PageSEO seoData={card["seo"]} />
            <div className="rounded-[10px] flex flex-col justify-center">
              <div>
                {card.title && card.image && card.bank && card.bank.image && (
                  <CreditCardHeading
                    title={card.title}
                    image={card.image}
                    logo={card.bank.image}
                    bankName={card.bank.title}
                    rating={card.rating}
                  />
                )}
              </div>
              <div className="flex justify-center mt-10">
                <Link
                  to={`${card.apply_link}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-[#00C6CA]  text-[#FFFFFF] font-montserrat text-[14px] w-[128px] h-[30px]  rounded-[5px] flex justify-center items-center">
                    Apply Now
                  </button>
                </Link>
              </div>

              <div className="flex justify-center mt-8">
                <FeaturesCom data={getKeyFeature(card)} />
              </div>

              <div className="mt-4 flex justify-center">
                <FeesAndCharges data={getFeeAndCharges(card)} />
              </div>

              <div className="flex justify-center mt-4">
                <AboutComp2 data={card.description} />
              </div>

              <div className="flex justify-center mt-4">
                <FeaturesInfoComp data={card.features_long} />
              </div>

              <div className="mt-4 flex justify-center">
                <div className="rounded-[10px] border-solid border-[1px] border-black px-5 pb-4 w-[95vw]">
                  <div
                    className="bulletPointUL text-black text-base"
                    dangerouslySetInnerHTML={{ __html: card.review }}
                  ></div>
                </div>
              </div>

              <div className="flex  justify-center  mt-10 w-[90vw] md:w-full">
                <p className=" font-montserrat font-semibold text-[20px] leading-[24.38px] text-center text-black">
                  More Cards - {card.bank.title}
                </p>
              </div>

              <div className="flex flex-col items-center mb-10">
                <div className="md:grid md:grid-cols-3 md:gap-4 md:mt-4 md:mb-4 md:mx-3">
                  {card &&
                    card?.similar?.map((item) => (
                      <div className="flex justify-center my-4">
                        <CreditCardProp
                          title={item.title}
                          img={item.image}
                          joining_fees={item.joining_fees}
                          renewal_fees={item.renewal_fees}
                          id={item.id}
                          apply={item.apply_link}
                          lang={lang}
                        />
                      </div>
                    ))}
                </div>
              </div>

              <div className="flex justify-center  mt-10 w-[90vw] md:w-full">
                <p className=" font-montserrat font-semibold text-[20px] leading-[24.38px] text-center text-black">
                  Compare Cards with {card.title}
                </p>
              </div>

              <div className="flex flex-col items-center mb-10">
                <div className="md:grid md:grid-cols-3 md:gap-4 md:mt-4 md:mb-4 md:mx-3">
                  {card &&
                    card?.similar1?.map((item) => (
                      <div className="flex justify-center my-4">
                        <CreditCardProp
                          title={item.title}
                          img={item.image}
                          joining_fees={item.joining_fees}
                          renewal_fees={item.renewal_fees}
                          id={item.id}
                          apply={item.apply_link}
                          isComparision={true}
                          onComparisionClick={() => {
                            navigate(
                              `/${lang}/credit-cards-compare/${
                                card.id + "-vs-" + item.id
                              }`
                            );
                          }}
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </>
        )}
    </>
  );
};

export default IndivdualCreditCard;
